module.exports = __webpack_public_path__ + "a3d8a957ebf412b7354279725a7c3619.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img4.jpg
// module id = 249
// module chunks = 2